import { Dialog } from "primereact/dialog";
import CloseModal from "../../../images/icon_close_modal.svg";
import ImgCheckSuccessGif from "../../../images/animation-check-proority-black.gif";
import { BottonCommon } from "../BottonCommon/BottonCommonStyled";
import {
  ContainerModalSucess,
  ContentModalSucess,
} from "./ModalSuccessConfirmationStyled";

interface Props {
  buttonLabel: string;
  message: string;
  onAccept: () => void;
  onClose: () => void;
  showProcessing: boolean;
  title: string;
}
export const ModalSuccessConfirmation = ({
  buttonLabel,
  message,
  onAccept,
  onClose,
  showProcessing = false,
  title,
}: Props) => {
  return (
    <Dialog
      style={{ width: "45rem", height: "42rem" }}
      className="img-processing-talma-class"
      showHeader={false}
      visible={showProcessing}
      onHide={() => {}}
      draggable={false}
      resizable={false}
    >
      <ContainerModalSucess>
        <div className="close-modal-button">
          <img
            src={CloseModal}
            alt="close modal"
            className="close-button"
            onClick={() => {
              onClose();
            }}
          />
        </div>
        <ContentModalSucess>
          <img src={ImgCheckSuccessGif} alt="" className="icon-check-success" />
          <h1>{title}</h1>
          <p>{message}</p>
          <div style={{ marginTop: "2.8rem" }}>
            <BottonCommon
              onClick={() => {
                onAccept();
              }}
              backgroundColor="#88B13B"
              width="33.2rem"
            >
              {buttonLabel}
            </BottonCommon>
          </div>
        </ContentModalSucess>
      </ContainerModalSucess>
    </Dialog>
  );
};
